module.exports = __webpack_public_path__ + "static/img/fz_thb_tb.27fbd9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_thb_tb.png
// module id = Es3N
// module chunks = 0